/**
 * Strips out any HTML tags and returns the inner text
 *
 * @param str - A string containing HTML
 * @returns A HTMLless string
 */
const stripHtml = (str: string) => {
  const tmp = document.createElement("div");

  tmp.innerHTML = str;

  return tmp.textContent || tmp.innerText || "";
};

export default stripHtml;
